/* product-share.js — <product-share> custom element
   - Reveals the native-share button only when navigator.share is available
   - Copy-to-clipboard with a brief confirmation state
*/
(function () {
  if (customElements.get('product-share')) return;

  class ProductShare extends HTMLElement {
    connectedCallback() {
      this.url = this.dataset.shareUrl || window.location.href;
      this.title = this.dataset.shareTitle || document.title;
      this.text = this.dataset.shareText || this.title;

      this.nativeBtn = this.querySelector('[data-share-native]');
      this.copyBtn = this.querySelector('[data-share-copy]');
      this.copyLabel = this.querySelector('[data-share-copy-label]');
      this._copyLabelDefault = this.copyLabel ? this.copyLabel.textContent : '';

      if (this.nativeBtn && typeof navigator.share === 'function') {
        this.nativeBtn.hidden = false;
        this.nativeBtn.addEventListener('click', this._onNative.bind(this));
      }
      if (this.copyBtn) {
        this.copyBtn.addEventListener('click', this._onCopy.bind(this));
      }
    }

    async _onNative() {
      try {
        await navigator.share({ title: this.title, text: this.text, url: this.url });
      } catch (e) { /* user dismissed */ }
    }

    async _onCopy() {
      const ok = await this._writeClipboard(this.url);
      if (ok && this.copyBtn) {
        this.copyBtn.classList.add('is-copied');
        if (this.copyLabel) this.copyLabel.textContent = this.copyBtn.dataset.copiedLabel || 'Copied!';
        setTimeout(() => {
          this.copyBtn.classList.remove('is-copied');
          if (this.copyLabel) this.copyLabel.textContent = this._copyLabelDefault;
        }, 1800);
      }
    }

    async _writeClipboard(text) {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
          return true;
        }
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        return true;
      } catch (e) {
        return false;
      }
    }
  }

  customElements.define('product-share', ProductShare);
})();
